<div *ngFor="let answer of answerList" class="pt-2">
  <div [innerHTML]="answer"></div>
</div>
